import type {
    ObjectShorthandValue,
    ProfessionalTileProps,
} from '@archipro-design/aria';
import { ProfessionalTile } from '@archipro-design/aria';
import { useRef, type ReactNode } from 'react';
import type { LogImpressionProps } from '@archipro-website/tracker';
import { useLogImpression } from '@archipro-website/tracker';

export type TileProps = ObjectShorthandValue<ProfessionalTileProps> & {
    impression?: LogImpressionProps;
};

const ProfessionalImpressionTile = (props: TileProps) => {
    const { impression, children, ...rest } = props;
    const ref = useRef<HTMLAnchorElement | null>(null);

    useLogImpression({ data: impression, ref });

    // Polymorphic tile ref (anchor vs div) — Aria’s generated ref type is an impossible intersection
    return (
        <ProfessionalTile ref={ref as never} {...rest}>
            {children as ReactNode}
        </ProfessionalTile>
    );
};

export default ProfessionalImpressionTile;
